module.exports = __webpack_public_path__ + "static/media/antenn.a1268bbb.mp3";